import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { FaStar, FaQuoteLeft } from 'react-icons/fa';
import './Testimonials.css';

const testimonials = [
  {
    name: 'Rahul Sharma',
    type: 'E-commerce Startup, Nashik',
    quote:
      'RRP & Associates handled everything from our GST registration to our website. The team is incredibly professional and responsive. They made our business setup effortless.',
    stars: 5,
  },
  {
    name: 'Priya Mehta',
    type: 'Restaurant Owner, Maharashtra',
    quote:
      'We got our FSSAI and Shop Act license within days! The pricing is very affordable and the team helped us understand every step of the process. Highly recommended!',
    stars: 5,
  },
  {
    name: 'Amit Patil',
    type: 'Digital Agency, Pune',
    quote:
      'Best decision for our company registration was choosing RRP & Associates. Their digital marketing support also helped us get our first 50 clients. Truly a one-stop solution.',
    stars: 5,
  },
];

export default function Testimonials() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-60px' });

  return (
    <section className="section testimonials" id="testimonials">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5 }}
        >
          <p className="section-label">Client Stories</p>
          <h2 className="section-title">Trusted by Startups & SMEs<br />Across India</h2>
          <div className="gold-divider" />
        </motion.div>

        <motion.div
          ref={ref}
          className="testimonials__grid"
          initial="hidden"
          animate={inView ? 'show' : 'hidden'}
          variants={{ hidden: {}, show: { transition: { staggerChildren: 0.15 } } }}
        >
          {testimonials.map((t) => (
            <motion.div
              key={t.name}
              className="testi-card"
              variants={{
                hidden: { opacity: 0, y: 40 },
                show: { opacity: 1, y: 0, transition: { duration: 0.55, ease: 'easeOut' } },
              }}
              whileHover={{ y: -5, boxShadow: '0 16px 40px rgba(201,168,76,0.12)' }}
            >
              <FaQuoteLeft className="testi-card__quote-icon" />
              <div className="testi-card__stars">
                {Array.from({ length: t.stars }).map((_, i) => (
                  <FaStar key={i} />
                ))}
              </div>
              <p className="testi-card__text">"{t.quote}"</p>
              <div className="testi-card__author">
                <div className="testi-card__avatar">{t.name[0]}</div>
                <div>
                  <strong>{t.name}</strong>
                  <span>{t.type}</span>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
